import { render, staticRenderFns } from "./VerifyInfoText.vue?vue&type=template&id=007f6a62&scoped=true"
import script from "./VerifyInfoText.vue?vue&type=script&lang=js"
export * from "./VerifyInfoText.vue?vue&type=script&lang=js"
import style0 from "./VerifyInfoText.vue?vue&type=style&index=0&id=007f6a62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007f6a62",
  null
  
)

export default component.exports